"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.navigateWithHref = exports.generateStateQueryString = exports.getHrefWithLocale = exports.extractSlugLocale = exports.getLocalePattern = exports.setFalseLocales = exports.setLocalePattern = exports.getHref = exports.convertHrefTemplate = exports.determineExternal = exports.hrefIsActive = exports.getCurrentUrl = exports.isAbsolutePath = exports.splitUrl = void 0;
const common_1 = require("@epic-core/common");
const common_2 = require("@epic-core/common");
const window_or_global_1 = __importDefault(require("window-or-global"));
const url_parse_1 = __importDefault(require("url-parse"));
const epicGamesOriginRegex = /(epicgames.com|epicgames.net|fortnite.com|fallguys.com|twinmotion.com|unrealengine.com)/g;
const absRegex = new RegExp(/^(http:\/\/|https:\/\/|\/\/)/i);
const splitUrl = (url) => {
    let base = url;
    if (url && url.length) {
        const hashParts = url.split('#');
        if (hashParts && hashParts.length > 0 && hashParts[0] && hashParts[0].length > 0) {
            base = hashParts[0];
        }
        else {
            //console.warn('[EGH] splitUrl() failed to split hash [#]');
        }
        const searchParts = base.split('?');
        if (searchParts && searchParts.length > 0 && searchParts[0] && searchParts[0].length > 0) {
            base = searchParts[0];
        }
        else {
            console.warn('splitUrl() failed to split search [?]');
        }
    }
    else {
        console.error(`splitUrl() bad url asked to parse ${url}`);
    }
    return base;
};
exports.splitUrl = splitUrl;
const isAbsolutePath = (url) => {
    return absRegex.test(url);
};
exports.isAbsolutePath = isAbsolutePath;
const getCurrentUrl = () => {
    return `${(0, common_2.getWindowLocationOrigin)()}${window_or_global_1.default.location.pathname}`;
};
exports.getCurrentUrl = getCurrentUrl;
const hrefIsActive = (unsanitizedHref = '', locale) => {
    if (!unsanitizedHref)
        return false;
    const href = (0, exports.splitUrl)(unsanitizedHref);
    if ((0, exports.isAbsolutePath)(href)) {
        const currentUrl = (0, exports.getCurrentUrl)();
        return href === currentUrl;
    }
    const hrefPathname = href.replace((0, common_1.getPath)(), '/');
    const currentPathname = window_or_global_1.default.location.pathname;
    return href === currentPathname || `${(0, common_1.getPath)()}${locale}${hrefPathname}` === currentPathname;
};
exports.hrefIsActive = hrefIsActive;
const determineExternal = (href) => {
    const egh = window_or_global_1.default._epicGamesNav || {};
    const egf = window_or_global_1.default._epicGamesFooter || {};
    const serverUrl = egh.serverUrl || egf.serverUrl;
    const isEmbeddedHeaderFooter = !!serverUrl;
    if (!href) {
        return {
            isExternal: false,
            sameOrigin: true,
            serverUrl,
            isEmbeddedHeaderFooter,
            isMailTo: false,
            isLauncher: false
        };
    }
    // FIXME: there is a bug here that is causing different output in node vs browser env
    // `parse` will use the location as the baseUrl in case of relative link in the browser env
    // while in node it'll be empty. This will cause SSR to mark a link as a different origin while
    // the app in the browser might consider it the same origin
    const parsedUrl = (0, url_parse_1.default)(href);
    const matches = parsedUrl.hostname.match(epicGamesOriginRegex);
    const sameOrigin = (matches && matches.length && matches.length > 0) || false;
    const isExternal = href.indexOf('http') === 0;
    const isMailTo = href.indexOf('mailto:') === 0;
    const isLauncher = href.indexOf('com.epicgames.launcher:') === 0;
    return { isExternal, sameOrigin, isMailTo, isLauncher, isEmbeddedHeaderFooter, serverUrl };
};
exports.determineExternal = determineExternal;
const convertHrefTemplate = (hrefTemplate, locale) => {
    if (!hrefTemplate)
        return '';
    //check for header/footer use outside of intended appContext
    const egh = window_or_global_1.default._epicGamesNav || {};
    const egf = window_or_global_1.default._epicGamesFooter || {};
    const serverUrl = egh.serverUrl || egf.serverUrl;
    const context = (0, common_1.getPath)(); //e.g. /fortnite/
    const contextNoSlash = context.replace(/\//g, '');
    const replacedLocale = hrefTemplate.replace('{locale}', locale);
    if (serverUrl) {
        return replacedLocale.replace('/{context}', serverUrl).replace('{context}', serverUrl);
    }
    return replacedLocale.replace('{context}', contextNoSlash);
};
exports.convertHrefTemplate = convertHrefTemplate;
const getHref = ({ href, hrefTemplate, locale }) => {
    if (hrefTemplate && locale) {
        return (0, exports.convertHrefTemplate)(hrefTemplate, locale);
    }
    return href || '';
};
exports.getHref = getHref;
/**
 * Regular expression to detect a locale in the path. It can be updated with setLocalePattern
 */
let localePattern;
const getDefaultLocalePattern = () => {
    return new RegExp(`^${(0, common_1.getPath)()}([a-zA-Z0-9]{2}(?:[-_][a-zA-Z0-9]{2,4}){0,2})(/.*)?$`);
};
const setLocalePattern = (pattern) => {
    if (pattern) {
        localePattern = pattern;
    }
    if (!pattern && !localePattern) {
        localePattern = getDefaultLocalePattern();
    }
};
exports.setLocalePattern = setLocalePattern;
const setFalseLocales = (negativeLookupArray) => {
    if (negativeLookupArray && negativeLookupArray.length) {
        const negativeLookupStr = negativeLookupArray.join('|');
        (0, exports.setLocalePattern)(new RegExp(`^${(0, common_1.getPath)()}((?!${negativeLookupStr})[a-zA-Z0-9]{2}(?:[-_][a-zA-Z0-9]{2,4}){0,2})(/.*)?$`));
    }
};
exports.setFalseLocales = setFalseLocales;
/**
 * A safe to use locale pattern regex.
 */
const getLocalePattern = () => {
    if (!localePattern) {
        localePattern = getDefaultLocalePattern();
    }
    return localePattern;
};
exports.getLocalePattern = getLocalePattern;
const DEFAULT_LOCALE = 'en-US';
function extractSlugLocale(pathname, locale) {
    const matches = (0, exports.getLocalePattern)().exec(pathname);
    //remove locale path from url if locale is present
    let pageSlug = pathname;
    let pageLocale;
    if (matches && matches.length && matches[1] && matches[2]) {
        //for paths like /ja/home
        pageSlug = matches[2];
        pageLocale = locale || matches[1] || DEFAULT_LOCALE;
    }
    else if (matches && matches.length && matches[1] && !matches[2]) {
        //for paths like /ja there won't be a second match
        pageSlug = (0, common_1.getPath)();
        pageLocale = locale || matches[1] || DEFAULT_LOCALE;
    }
    else {
        pageLocale = locale || DEFAULT_LOCALE;
    }
    (0, exports.getLocalePattern)().lastIndex = 0;
    return { pageSlug, pageLocale };
}
exports.extractSlugLocale = extractSlugLocale;
const getHrefWithLocale = ({ href, hrefTemplate, hrefGenerator, locale }) => {
    if (hrefTemplate) {
        const localeHref = (0, exports.convertHrefTemplate)(hrefTemplate, locale);
        return { localeHref, isExternal: false };
    }
    if (hrefGenerator && typeof hrefGenerator === 'function') {
        return { wholePath: hrefGenerator(href, (0, common_1.getPath)(), locale), isExternal: false };
    }
    if (!href)
        return {};
    const { isExternal, isEmbeddedHeaderFooter, serverUrl } = (0, exports.determineExternal)(href);
    let localeHref = href;
    let serverUrlContext = '';
    let wholePath = '';
    const context = (0, common_1.getPath)(); //e.g. /fortnite/
    if (!isExternal) {
        const { pageSlug } = extractSlugLocale(href, locale);
        if (pageSlug !== '#') {
            const slugWithoutContext = pageSlug.replace(context, '/');
            const slugNeedsSlash = slugWithoutContext[0] !== '/';
            wholePath = `${locale || 'en-US'}${slugNeedsSlash ? '/' : ''}${slugWithoutContext}`;
            if (isEmbeddedHeaderFooter) {
                const serverUrlParts = serverUrl.match(/\.[\w]{3}(\/.*)/);
                if (serverUrlParts && serverUrlParts.length && serverUrlParts[1]) {
                    serverUrlContext = serverUrlParts[1]; //e.g. /site
                    localeHref = `${serverUrl}/${wholePath.replace(serverUrlContext, '')}`;
                }
                else {
                    localeHref = `${serverUrl}/${wholePath}`;
                }
            }
            else {
                localeHref = `${context}${wholePath}`;
            }
        }
    }
    return { localeHref, isExternal, serverUrlContext, context, wholePath, serverUrl };
};
exports.getHrefWithLocale = getHrefWithLocale;
const convertLocaleToUnderscore = (locale) => {
    return locale.replace('-', '_');
};
const generateStateQueryString = (locale, params) => {
    const parsedUrl = (0, url_parse_1.default)(window_or_global_1.default.location.href, true);
    const query = parsedUrl.query || {};
    const state = query.state || '';
    const paramsObj = Object.assign({ state: state || parsedUrl.pathname || '/' }, params);
    if (locale) {
        paramsObj.lang = convertLocaleToUnderscore(locale);
    }
    const queryString = `?${(0, common_2.processParams)(paramsObj)}`;
    return queryString;
};
exports.generateStateQueryString = generateStateQueryString;
const navigateWithHref = (href = '', locale) => {
    if (!href)
        return;
    const queryString = (0, exports.generateStateQueryString)(locale);
    window_or_global_1.default.location.href = `${href}${queryString}`;
};
exports.navigateWithHref = navigateWithHref;
//# sourceMappingURL=urlUtils.js.map